"use client";

import { c as _c } from "react/compiler-runtime";
import SelectBox, { SelectBoxItem } from "@/components/ui/SelectBox";
import RadioSelectBox, { RadioSelectBoxItem } from "@/components/ui/RadioSelectBox";
import RangeSelectBox from "@/components/ui/RangeSelectBox";
import RadioButton from "@/components/ui/RadioButton";
import Checkbox from "@/components/ui/Checkbox";
export type YearType = "gregorian" | "persian";
export interface FilterContentProps {
  genres: SelectBoxItem[];
  countries: SelectBoxItem[];
  sortOptions: RadioSelectBoxItem[];
  selectedGenres: string[];
  selectedCountries: string[];
  yearType: YearType;
  range: [number, number] | undefined;
  handleGenresChange: (items: string[]) => void;
  handleCountriesChange: (items: string[]) => void;
  handleYearType: (type: YearType) => void;
  handleRangeChange: (val: [number, number]) => void;
  handleRangeChangeFinal: (val: [number, number]) => void;
  updateQuery: (key: string, value: string | null) => void;
}
export const sortOptions: RadioSelectBoxItem[] = [{
  id: "1",
  label: "پیش‌فرض",
  value: "default"
}, {
  id: "2",
  label: "تازه‌های",
  value: "newest"
}, {
  id: "3",
  label: "امتیاز IMDB",
  value: "imdb"
}, {
  id: "4",
  label: "جدیدترین",
  value: "year_new"
}, {
  id: "5",
  label: "قدیمی‌ترین",
  value: "year_old"
}];
export default function FilterContent(t0) {
  const $ = _c(50);
  const {
    genres,
    countries,
    sortOptions,
    selectedGenres,
    selectedCountries,
    yearType,
    range,
    handleGenresChange,
    handleCountriesChange,
    handleYearType,
    handleRangeChange,
    handleRangeChangeFinal,
    updateQuery
  } = t0;
  let t1;
  if ($[0] !== updateQuery) {
    t1 = <Checkbox label={"\u0641\u06CC\u0644\u0645"} onChange={e => updateQuery("type", e.target.checked ? "movie" : null)} />;
    $[0] = updateQuery;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== updateQuery) {
    t2 = <Checkbox label={"\u0633\u0631\u06CC\u0627\u0644"} onChange={e_0 => updateQuery("type", e_0.target.checked ? "series" : null)} />;
    $[2] = updateQuery;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex items-center gap-6 border-b pb-4">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== genres || $[8] !== handleGenresChange || $[9] !== selectedGenres) {
    t4 = <SelectBox title={"\u0698\u0627\u0646\u0631\u0647\u0627"} items={genres} selectedItems={selectedGenres} onChange={handleGenresChange} placeholder={"\u062C\u0633\u062A\u062C\u0648 \u0698\u0627\u0646\u0631\u0647\u0627"} />;
    $[7] = genres;
    $[8] = handleGenresChange;
    $[9] = selectedGenres;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== countries || $[12] !== handleCountriesChange || $[13] !== selectedCountries) {
    t5 = <SelectBox title={"\u06A9\u0634\u0648\u0631 \u0633\u0627\u0632\u0646\u062F\u0647"} items={countries} selectedItems={selectedCountries} onChange={handleCountriesChange} placeholder={"\u062C\u0633\u062A\u062C\u0648 \u06A9\u0634\u0648\u0631\u0647\u0627"} />;
    $[11] = countries;
    $[12] = handleCountriesChange;
    $[13] = selectedCountries;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="font-medium text-sm">نوع سال</span>;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = yearType === "gregorian";
  let t8;
  if ($[16] !== handleYearType) {
    t8 = () => handleYearType("gregorian");
    $[16] = handleYearType;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <RadioButton id="year-gregorian" name="yearType" label={"\u0645\u06CC\u0644\u0627\u062F\u06CC"} checked={t7} onChange={t8} />;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = yearType === "persian";
  let t11;
  if ($[21] !== handleYearType) {
    t11 = () => handleYearType("persian");
    $[21] = handleYearType;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <RadioButton id="year-persian" name="yearType" label={"\u0634\u0645\u0633\u06CC"} checked={t10} onChange={t11} />;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t9) {
    t13 = <div className="flex items-center gap-4">{t9}{t12}</div>;
    $[26] = t12;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const t14 = yearType === "gregorian" ? 1950 : 1329;
  const t15 = yearType === "gregorian" ? 2026 : 1404;
  let t16;
  if ($[29] !== handleRangeChange || $[30] !== handleRangeChangeFinal || $[31] !== range || $[32] !== t14 || $[33] !== t15 || $[34] !== yearType) {
    t16 = <RangeSelectBox key={yearType} title={"\u0633\u0627\u0644 \u0633\u0627\u062E\u062A"} min={t14} max={t15} step={1} value={range} onChange={handleRangeChange} onFinalChange={handleRangeChangeFinal} />;
    $[29] = handleRangeChange;
    $[30] = handleRangeChangeFinal;
    $[31] = range;
    $[32] = t14;
    $[33] = t15;
    $[34] = yearType;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t13 || $[37] !== t16) {
    t17 = <div className="flex flex-col gap-2 border-b pb-4">{t6}{t13}{t16}</div>;
    $[36] = t13;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== updateQuery) {
    t18 = value => updateQuery("sort", value);
    $[39] = updateQuery;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== sortOptions || $[42] !== t18) {
    t19 = <RadioSelectBox title={"\u0645\u0631\u062A\u0628 \u0633\u0627\u0632\u06CC"} items={sortOptions} onChange={t18} />;
    $[41] = sortOptions;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t17 || $[45] !== t19 || $[46] !== t3 || $[47] !== t4 || $[48] !== t5) {
    t20 = <div className="flex flex-col gap-5">{t3}{t4}{t5}{t17}{t19}</div>;
    $[44] = t17;
    $[45] = t19;
    $[46] = t3;
    $[47] = t4;
    $[48] = t5;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  return t20;
}